<template>
  <section :id="`comp_id_${compProps.elementId}`" :padding="imgs&&imgs.privateProps.padding">
    <component v-if="isShow" :is="compName" :compProps="uiProps" :labelKey="labelKey" :compId="(compProps.elementId+'')" @action="actionHandle"></component>
    <component :is="servCompName" :payLoad="payLoad" :compIndex="compIndex" :compProps="compProps" @init="initHandle" @finish="finishHandle"></component>
  </section>
</template>
<script>
/* eslint-disable */
import ImageTiled from '@/components/ImageTiled'
import ImageSlide from '@/components/ImageSlide'
import ImageSwiper from '@/components/ImageSwiper'
import ImageMotion from '@/components/ImageMotion'
import ImageBottomSuction from '@/components/ImageBottomSuction'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'
import { eventBus } from '@/utils'
import { Sniff } from '@/utils/q_sniff'

export default {
  mixins: [mixin],
  data() {
    return {
      payLoad: null,
      labelKey: '',
      imgUrl: '',
      uiProps: {}
    }
  },
  components: {
    ImageTiled,
    ImageSlide,
    ImageSwiper,
    ImageMotion,
    ImageBottomSuction,
    ...serviceComps
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    compName() {
      switch (this.compProps.mate.mode + '') {
      case '0': // 平铺
        return 'ImageTiled'
      case '1': // 轮播
        return 'ImageSwiper'
      case '2': // 平滑
        return 'ImageSlide'
      case '3': // 重叠
        return 'ImageMotion'
      case '4': // 吸底
        return 'ImageBottomSuction'
      default:
        return ''
      }
    },
    imgs() {
      if (this.compProps.mate) {
        return this.compProps.mate
      } else {
        return null
      }
    },
    isShow() {
      if (process.env.VUE_APP_LOCAL == 'Q') {
        const { disablApp, disablMp, disablWeb  } = this.compProps.mate.privateProps
        if (Sniff.miniprogram) {
          if (disablMp) {
            return false
          }
          return true
        }
        if (Sniff.qunar) {
          if (disablApp) {
            return false
          }
          return true
        }
        if (!Sniff.qunar) {
          if (disablWeb) {
            return false
          }
          return true
        }
        return true
      } else {
        return true
      } 
    }
  },
  mounted() {
    this.compProps.mate.items.forEach((item) => {
      this.imgUrl = item.imgLink
    })
    window._fas && window._fas.setCustomTrack({
      eventname: 'C_HOME_CMS_TRAVELAROUND_ELEMNT_EXPOSURE',
      ext: {
        elementId: this.compProps.elementId,
        elementName: this.compProps.elementName,
        elementType: 2,
        url: 'https://pic.tujia.com' + this.imgUrl,
        rank_list_id: this.$root.promotionId,
        rank_list_name: this.$root.htmlTitle
      }
    })
    const { isLinkFilter } = this.compProps.mate
    if (isLinkFilter) {
      const { labelkey_2 } = this.$route.query
      labelkey_2 && (this.labelKey = labelkey_2)
      eventBus.$on('filter_change', (content) => {
        this.labelKey = content.labelKey
      })
    }
  },
  methods: {
    initHandle(payload) {
      const mate = this.compProps?.mate || {}
      this.uiProps = {
        ...mate,
        itmes: payload.items,
        timeStamp: new Date().getTime()
      }
    },
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payload) {
      if (!this.$root.isPreview) {
        this.payLoad = payload
      }
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_TRAVELAROUND_ELEMNT_CLICK',
        ext: {
          elementId: this.compProps.elementId,
          elementName: this.compProps.elementName,
          elementType: 2,
          url: 'https://pic.tujia.com' + this.payLoad.imgLink,
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle,
          active_link: this.payLoad.activeLink,
          app_link: this.payLoad.appLink,
          mp_link: this.payLoad.mpLink,
          c_app_link: this.payLoad.cAppLink
        }
      })
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle() {
      this.payLoad = null
    }
  }
}
</script>
<style lang="scss" scoped>
.img-container {
  max-width: 100%;
}
</style>
